import DataBreakdownTableScroll from './DataBreakdownTableScroll'

export default DataBreakdownTableScroll
